import { handleActions } from 'redux-actions';
import types from '@/actions/noticeTypes';

const initialState = {
  alarmFlag: false
};

/* Reducer */
export default handleActions({
  [types.SET_ALARM_FLAG]: (state, action) => {
    return { ...state,
      alarmFlag: action.flag
    }
  },
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/noticeReducer.js